export default function AttachPreparationItemFolderController(
  $rootScope,
  $scope,
  $q,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  userService,
  amDataService,
  docDataService
) {
  const vm = this;

  vm.canExpand = vm.status !== 'No Folder Added';
  vm.isExpanded = false;
  vm.loaded = false;
  vm.loading = false;

  vm.handleExpandFolder = _handleExpandFolder;
  vm.handleAttachFolder = _handleAttachFolder;

  function _handleExpandFolder() {
    vm.isExpanded = !vm.isExpanded;

    if (vm.isExpanded) {
      _refreshFolder();
    }
  }

  function _refreshFolder() {
    vm.loaded = false;
    loaderService.showViewLoader = true;

    docDataService.getChildItemList(vm.serviceId, vm.folder.documentId).then((response) => {
      vm.folder.childDocuments = $filter('filter')(response.data.ChildDocuments, { documentTypeId: 0 });
      vm.folder.childFolders = $filter('filter')(response.data.ChildDocuments, { documentTypeId: 1 });

      $q.all([
        _updateChildDocuments(),
        _updateChildFolders(),
      ]).then(() => {
        vm.loaded = true;
        loaderService.showViewLoader = false;
      });
    });
  }

  function _updateChildDocuments() {
    const dfdUpdate = $q.defer();
    if (vm.folder.childDocuments.length > 0) {
      amDataService.getPreparationItemDocumentsByFolder(vm.folder.documentId).then((response) => {
        const assignedDocs = response.data.result;
        if (assignedDocs.length > 0) {
          assignedDocs.forEach((assignedDoc) => {
            vm.folder.childDocuments.forEach((childDoc) => {
              if (childDoc.documentId === assignedDoc.documentId
                && assignedDoc.preparationItemId === vm.preparationItemId) {
                childDoc.preparationItemDocumentId = assignedDoc.preparationItemDocumentId;
                childDoc.attached = true;
              }
            });
          });
        }
        dfdUpdate.resolve();
      });
    } else {
      dfdUpdate.resolve();
    }
    return dfdUpdate.promise;
  }

  function _updateChildFolders() {
    const dfdUpdate = $q.defer();
    if (vm.folder.childFolders.length > 0) {
      amDataService.getPreparationItemFoldersByFolder(vm.folder.documentId).then((response) => {
        const assignedFolders = response.data.result;
        if (assignedFolders.length > 0) {
          assignedFolders.forEach((assignedFolder) => {
            vm.folder.childFolders.forEach((childFolder) => {
              if (childFolder.documentId === assignedFolder.folderId
                && assignedFolder.preparationItemId === vm.preparationItemId) {
                childFolder.preparationItemFolderId = assignedFolder.preparationItemFolderId;
                childFolder.attached = true;
              }
            });
          });
        }
        dfdUpdate.resolve();
      });
    } else {
      dfdUpdate.resolve();
    }
    return dfdUpdate.promise;
  }

  function _handleAttachFolder() {
    const dfdSave = $q.defer();

    if (vm.folder.attached) {
      amDataService.attachPreparationItemFolder(vm.preparationItemId, vm.folder.documentId).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while attaching the Folder.');
          dfdSave.reject();
        } else {
          alerts.success(`Folder ${vm.folder.name} has been attached successfully.`);
          vm.folder.preparationItemFolderId = response.data.preparationItemFolderId;
          $rootScope.$broadcast('refreshAMPreparationItemFolders', { preparationItemId: vm.preparationItemId });
          $rootScope.$broadcast('refreshAMPreparationItemDocuments', { preparationItemId: vm.preparationItemId });
          dfdSave.resolve();
        }
      });
    } else {
      amDataService.detachPreparationItemFolder(vm.folder.preparationItemFolderId).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while detaching the Folder.');
          dfdSave.reject();
        } else {
          alerts.success(`Folder ${vm.folder.name} has been detached successfully.`);
          vm.folder.preparationItemFolderId = null;
          $rootScope.$broadcast('refreshAMPreparationItemFolders', { preparationItemId: vm.preparationItemId });
          $rootScope.$broadcast('refreshAMPreparationItemDocuments', { preparationItemId: vm.preparationItemId });
          dfdSave.resolve();
        }
      });
    }
  }
}

AttachPreparationItemFolderController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'userService',
  'amDataService',
  'docDataService'
];
